var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71533 7.92773C9.70633 7.92773 11.5513 6.57531 11.5513 4.07031C11.5513 1.58131 9.70633 0.230469 6.71533 0.230469H2.14551V8.90039H0.445312V9.83936H2.14551V11.7686H3.82471V9.83936H7.51367V8.90039H3.82471V7.92773H6.71533ZM9.87354 4.08643C9.87354 5.65243 8.74233 6.55957 6.71533 6.55957H3.82373V1.65967H6.71533C8.74233 1.66467 9.87354 2.52043 9.87354 4.08643Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuble);
export default __webpack_public_path__ + "static/media/ruble.0641d657.svg";
export { ForwardRef as ReactComponent };